import React from 'react';
import { useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import { Container } from './styles';
import OpenOrdersFilters from '../../OpenOrdersFilters';
import OpenOrdersTable from '../Tables/OpenOrdersTable';
import { ApplicationState } from '../../../../../store';
import {
  EOrderTab,
  ILongSteelOrderData,
  IOpenOrderData
} from '../../../../../store/ducks/long-steel-orders/types';
import {
  ECustomerTypeView,
  IUserPreference,
  IUserOrderItemPreference,
  EUserPreferenceType
} from '../../../../../store/ducks/user/types';

interface IOpenOrdersProps {
  loading: boolean;
  selectedTab?: EOrderTab;
  orderTab?: EOrderTab;
  customerViewType: ECustomerTypeView;
  filteredOrders: ILongSteelOrderData[];
  setFilteredOrders(filteredOrders: ILongSteelOrderData[]): void;
  onCleanFilters(): void;
  loadOrders(
    states: string[],
    emitterIds: string[],
    startDate?: string,
    endDate?: string
  ): void;
  receiverId: string;
  setReceiverId(receiverId: string): void;
  emitterIds: string[];
  setEmitterIds(emitterIds: string[]): void;
}

const defaultOrderUserPreference: IUserPreference = {
  name: EUserPreferenceType.ORDERS,
  ordersItens: {
    idOrder: '0',
    idProduct: '0'
  }
};

const OpenOrders: React.FC<IOpenOrdersProps> = ({
  loading,
  selectedTab,
  orderTab,
  customerViewType,
  filteredOrders,
  setFilteredOrders,
  onCleanFilters,
  loadOrders,
  receiverId,
  setReceiverId,
  emitterIds,
  setEmitterIds
}) => {
  const ordersState = useSelector(
    (state: ApplicationState) => state.longSteelOrders
  );
  const orderUserPreference =
    useSelector(
      (state: ApplicationState) =>
        state.user.preferences.find(
          (pref) => pref.name === 'orders'
        ) as IUserPreference
    ) || defaultOrderUserPreference;

  return (
    <Container>
      <div>
        {ordersState.items.length > 0 && (
          <OpenOrdersFilters
            orderState={ordersState}
            customerViewType={customerViewType}
            orderTab={orderTab}
            onCleanFilters={onCleanFilters}
            loadOrders={loadOrders}
            isFiltered={filteredOrders.length !== ordersState.items.length}
            setFilteredOrders={setFilteredOrders}
            receiverId={receiverId}
            setReceiverId={setReceiverId}
            emitterIds={emitterIds}
            setEmitterIds={setEmitterIds}
          />
        )}

        {(loading || !selectedTab) && (
          <>
            <Skeleton count={5} width={'16%'} style={{ margin: '1rem 2%' }} />
            <Skeleton count={5} width={'96%'} style={{ margin: '0.5rem 2%' }} />
          </>
        )}

        {!loading && orderUserPreference && selectedTab === EOrderTab.OPEN && (
          <OpenOrdersTable
            filteredOrders={filteredOrders as IOpenOrderData[]}
            userOrderPreference={
              orderUserPreference.ordersItens as IUserOrderItemPreference
            }
            customerViewType={customerViewType}
          />
        )}
      </div>
    </Container>
  );
};

export default OpenOrders;
